/** Small transient messages at the top of the screen. */
export function showToast(text: string, ms = 2800): void {
  const container = document.getElementById('toasts')!;
  const el = document.createElement('div');
  el.className = 'toast';
  el.textContent = text;
  container.appendChild(el);
  setTimeout(() => el.classList.add('gone'), ms);
  setTimeout(() => el.remove(), ms + 400);
}
